module.exports = __webpack_public_path__ + "img/ESET SUPPORT.050d2d33.png";